import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/do'

import { Store } from '@ngrx/store'
import { AppState } from '../reducers'

import { StaticContent, Video } from '../models'
import { PaginatedList } from '../libs/infinite-paginator'
import { StaticContentApi } from '../apis/'
import { SelectStaticContent, SetStaticContentList, SetVideoStaticContents } from '../actions/static-content'

@Injectable()
export class StaticContentService {
  constructor(
    private store: Store<AppState>,
    private api: StaticContentApi,
  ) { }

  loadVideoStaticContents(videoId: number): Observable<StaticContent[]> {
    const list = this.api.index(videoId)
    this.store.dispatch(new SetStaticContentList(list))

    return list.items.do(l => this.store.dispatch(new SetVideoStaticContents(videoId, l)))
  }

  selectStaticContent(staticContentId: number): Observable<StaticContent> {
    return this.api.get(staticContentId).do(v => this.store.dispatch(new SelectStaticContent(v)))
  }

  update(staticContentId: number, params: any): Observable<StaticContent> {
    return this.api.update(staticContentId, params)
      .do(v => this.store.dispatch(new SelectStaticContent(v)))
  }

  create(videoId: number, name: string, file: ActiveStorage.Blob): Observable<StaticContent> {
    return this.api.create(videoId, name, file)
      .do(v => this.store.dispatch(new SelectStaticContent(v)))
  }
}



// WEBPACK FOOTER //
// ./src/services/static-content.ts